/* MoyPickerComponent.js */

"use strict";
const Renderer = require("./MoyPickerRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class MoyPickerComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
}
module.exports = MoyPickerComponent;
